export const formatBanListColumns = (columns) => {
  const checkboxColumn = [
    {
      field: '',
      checkboxSelection: true,
      filter: false,
      suppressHeaderMenuButton: true,
      resizable: true,
    },
  ];

  let result = [];

  if (columns && columns.length > 0) {
    columns.forEach((val, index) => {
      if (val.fieldNameCamelCase === 'banByMemberName') {
        result.push({ ...val, resizable: true, width: 240 });
      } else if (val.fieldNameCamelCase === 'bannedMemberName') {
        result.push({ ...val, resizable: true, flex: 1 });
      }
    });
  }
  return [...checkboxColumn, ...result];
};
